import React, { Component } from 'react';
import NotificationStore from './NotificationStore';
import './NotificationCenter.css';

// Reuses react-notifications' CSS classes (notifications.css is imported in App.js);
// NotificationCenter.css repositions the stack to the bottom-right, makes the empty
// area of the container click-through and styles the explicit close button.

class NotificationToast extends Component {

    componentDidMount() {
        const { notification, onRequestHide } = this.props;
        if (notification.timeOut !== 0) {
            this.timer = setTimeout(onRequestHide, notification.timeOut);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    handleClick = () => {
        const { notification, onRequestHide } = this.props;
        if (notification.onClick) {
            notification.onClick();
        }
        onRequestHide();
    }

    handleClose = (e) => {
        e.stopPropagation();
        this.props.onRequestHide();
    }

    render() {
        const { notification } = this.props;

        return (
            <div className={`notification notification-${notification.type}`} onClick={this.handleClick}>
                <button type="button" className="notification-close" aria-label="Close" onClick={this.handleClose}>
                    &times;
                </button>
                {notification.title ? <h4 className="title">{notification.title}</h4> : ''}
                <div className="message">{notification.message}</div>
            </div>
        );
    }
}

export default class NotificationContainer extends Component {

    state = {
        notifications: NotificationStore.getVisible()
    };

    componentDidMount() {
        NotificationStore.addChangeListener(this.handleStoreChange);
    }

    componentWillUnmount() {
        NotificationStore.removeChangeListener(this.handleStoreChange);
    }

    handleStoreChange = (notifications) => {
        this.setState({ notifications });
    }

    handleRequestHide = (notification) => () => {
        NotificationStore.remove(notification);
    }

    render() {
        const { notifications } = this.state;

        return (
            <div className="notification-container hey-notification-container">
                {notifications.map(notification =>
                    <NotificationToast
                        key={notification.id}
                        notification={notification}
                        onRequestHide={this.handleRequestHide(notification)}
                    />
                )}
            </div>
        );
    }
}
